var _style, _desc, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupOfPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,36.8c0-0.6-0.5-1-1.1-1c-1.9,0-3.4-1.5-3.4-3.4c0-1.9,1.5-3.4,3.4-3.4c0.5,0,1.1-0.4,1.1-1 c0-0.6-0.4-0.7-1-0.7c-3,0-5.5,2.4-5.5,5.3c0,1.6,0.8,3.2,2.1,4.1c-2.7,1.3-4.4,3.8-4.4,6.7c0,0.5,0.4,1,1.1,1c0.7,0,1.1-0.4,1.1-1 c0-3,2.5-5.6,5.7-5.6C26.4,37.8,26.9,37.4,26.9,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.5,36.6c1.3-1,2.1-2.5,2.1-4.1c0-2.8-2.5-5.3-5.5-5.3c-0.5,0-1,0.1-1,0.7c0,0.6,0.5,1,1.1,1 c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4c-0.6,0-1.1,0.5-1.1,1c0,0.6,0.4,1,1,1c3.1,0,5.7,2.6,5.7,5.6c0,0.6,0.4,1,1.1,1 c0.6,0,1.1-0.4,1.1-1C52,40.5,50.2,37.9,47.5,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,37.1c2.1-1.4,3.7-3.7,3.7-6.5c0-4.3-3.5-7.7-7.7-7.7c-4.2,0-7.7,3.6-7.7,7.7c0,2.6,1.4,5.1,3.6,6.5 c-4,1.6-6.8,5.6-6.8,10.1H26c0-4.9,4-9,9-9c4.9,0,9,4,9,9h2.1C46,42.6,43,38.7,38.9,37.1z M34.8,36.2c-3,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.5,5.6-5.5c3.1,0,5.6,2.6,5.6,5.5C40.4,33.7,37.9,36.2,34.8,36.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOfPeople);
export default __webpack_public_path__ + "static/media/groupOfPeople.57bbe6b2.svg";
export { ForwardRef as ReactComponent };